module.exports = __webpack_public_path__ + "static/img/qr_circle_wechat_mini_mobile_2021.242bc07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr_circle_wechat_mini_mobile_2021.jpg
// module id = 773
// module chunks = 34